"use client" 

import UserProfile from "@/components/profile";

export default function StudentProfile() {
  return <UserProfile role = "student" />

  
}
